import React, { useState, useEffect } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import banner from "../../../images/banner-bg.png"
import Header from "../../components/Header/Header"
import Footer from "../../components/Footer/Footer"
import "./SingleCourse.scss"
import AOS from "aos";

import { AccountCircle, AccessTime, PlayLesson, PeopleAlt, Language, SettingsAccessibility, Quiz, VerifiedUser, CastForEducation, Check } from '@mui/icons-material';
const SingleWebDevelopment = () => {

    useEffect(() => {
        AOS.init({
            offset: 100,
            duration: 1000,
            easing: "ease"
        });
    });
    return (
        <>
            <Header />
            <div className="single-course-hero">
                <Container>
                    <Row className="align-items-center">
                        <Col lg={6}>
                            <div data-aos="fade-right" className="course-hero-left" data-aos="fade-left">
                                <h2>ফুল স্ট্যাক জাভাস্ক্রিপ্ট - মার্ন স্ট্যাক</h2>
                                <ul className="list">
                                    <li> কোর্সের মেয়াদ :   <span> ৪ মাস</span></li>
                                    <li> কোর্স ফি  :   <span>৮০০০ টাকা</span></li>
                                    <li>ক্লাসের সময় :   <span>সপ্তাহে ৬ দিন </span></li>
                                    <li> ক্লাস শুরুর তারিখ :    <span> ১ জুন ২০২২</span></li>
                                </ul>
                                <p>চার  মাসের চেষ্টায় সার্টিফাইড ফুল স্ট্যাক ওয়েব ডেভেলপার হওয়ার চ্যালেঞ্জ গ্রহণ করুন! এই ক্যারিয়ার ট্র্যাক প্রোগ্রামে অংশগ্রহণের মাধ্যমে ফ্রন্ট এন্ড, ব্যাক-এন্ড ও ডেটাবেজসহ সম্পূর্ণ ওয়েবসাইট  ডেভেলপ করার মতো দক্ষতা অর্জন করতে পারবেন</p>
                            </div>
                        </Col>
                        <Col lg={6}>
                            <div className="course-hero-right" data-aos="fade-right">
                                <img src={banner} alt="Image  not found " />
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>


            <div className="course-details">

                <Container>
                    <Row>
                        <Col lg={8} md={6}>
                            <div className="course-details-left" >
                                <div className="course-img" data-aos="zoom-out-up">
                                    <img src="https://edemy-react.envytheme.com/images/courses/courses2.jpg" alt="Image not  found " />
                                </div>
                                <div className="courses-details-desc-style-two" data-aos="zoom-out-up">
                                    <h3>কোর্স সম্পর্কে</h3>
                                    <p>জাভাস্ক্রিপ্ট কোর্সের প্রথম আড়াই মাস আমরা ফোকাস করবো জাভাস্ক্রিপ্ট ল্যাঙ্গুয়েজের উপর। জাভাস্ক্রিপ্টের একদম ব্যাসিক থেকে দেখানো হবে কোর্সে। এই কোর্সে অংশগ্রহণের পূর্বে জাভাস্ক্রিপ্টের কোনোরূপ পূর্ব অভিজ্ঞতা না থাকলেও চলবে তবে এইচটিএমএল / সিএসএসের উপর ব্যাসিক ধারণা থাকতে হবে। কোর্সে যদিও এইচটিএমএল / সিএসএসের একটা রিফ্রেশার দেওয়া হবে তবে মূল ফোকাসটাই থাকবে জাভাস্ক্রিপ্ট এবং রিয়্যাক্টের উপর। জাভাস্ক্রিপ্টের ডোম ম্যানিপুলেশন, ফাংশনাল প্রোগ্রামিং, অবজেক্ট অরিয়েন্টেড প্রোগ্রামিং এর কোর কনসেপ্ট কভার করা হবে। এছাড়াও জাভাস্ক্রিপ্ট ইউজ করে কিভাবে এপিআই থেকে ডাটা ফেচ করে আনা যায়, অ্যাসিঙ্ক্রোনাশ প্রোগ্রামিঙের খুঁটিনাটি সবকিছুরই বিস্তর আলোচনা হবে প্রথম আড়াই মাসে। এছাড়াও সাথে তো প্রজেক্ট থাকছেই। রিয়্যাক্ট জেএস জাভাস্ক্রিপ্টের খুঁটিনাটি পাকাপোক্ত করার পর আমরা ফোকাস করবো রিয়্যাক্ট এর উপর। প্রথম আড়াই মাসে আমরা জাভাস্ক্রিপ্টের যা কিছু শিখেছি সেটার উপরে ভিক্তি করেই আমরা আমাদের রিয়্যাক্ট এর জার্নি শুরু করে দিবো। রিয়্যাক্ট যে কত বেশি জোস একটা লাইব্রেরি সেটা আপনারাই বুঝতে শুরু করবেন। রিয়্যাক্ট এর কোর কনসেপ্টের উপর ফোকাস থাকবে কোর্সের প্রথমে এবং আমাদের এই পুরো সময়টা জুড়েই আমরা প্রোজেক্ট বেজড লার্নিং মেথড ফলো করবো। এক একটা করে কোর কনসেপ্টের পরে সেটা প্রোজেক্টে ব্যবহার করে রিয়েল লাইফ ইমপ্লিমেন্টেশন দেখবো। রিয়্যাক্ট এর দুইটা ইম্পরট্যান্ট কনসেপ্ট, রিডাক্স এবং রিয়্যাক্ট হুক্স নিয়ে বিস্তর আলোচনা করবো কোর্সে। রিয়্যাক্ট এর রিয়েল লাইফ ডিজাইন প্যাটার্ন, কম্পোনেন্ট লাইফসাইকেল, ডিবাগিং ইত্যাদি নিয়ে জানবো আমরা কোর্সে।  এছাড়াও গুগলের ফায়ারবেইজ, নোড, মঙ্গোডিবি, ইত্যাদি ব্যাকেন্ড ফিচারস নিয়েও আমরা পড়াশুনা করবো। এবং কোর্সের শেষে আমরা রিয়্যাক্ট দিয়ে একটি কমপ্লিট ফুলস্ট্যাক অ্যাপ ডেভেলপ করে সেটা হোস্ট করবো। এরই মাধ্যমে আমাদের লার্নিং সম্পূর্ণতা লাভ করবে।</p>


                                    <div className="courses-curriculum" data-aos="zoom-out-up">
                                        <h3>কোর্স মডিউল</h3>
                                        <ul>
                                            <li>
                                                <CastForEducation />
                                                <span>Module 01 : </span>
                                                Concept Of Web Design

                                            </li>
                                            <li>
                                                <CastForEducation />
                                                <span>Module 02 : </span>
                                                Bootstrap,Materialize,Semantic UI

                                            </li>
                                            <li>
                                                <CastForEducation />
                                                <span>Module 03 : </span>
                                                SCSS
                                            </li>
                                            <li>
                                                <CastForEducation />
                                                <span>Module 04 : </span>
                                                Concept Of ECMAScript
                                            </li>
                                            <li>
                                                <CastForEducation />
                                                <span>Module 05 : </span>
                                                DOM Manipulation
                                            </li>
                                            <li>
                                                <CastForEducation />
                                                <span>Module 06 : </span>
                                                Asynchronous Programming
                                            </li>
                                            <li>
                                                <CastForEducation />
                                                <span>Module 07 : </span>
                                                Hard Part Of JavaScript
                                            </li>
                                            <li>
                                                <CastForEducation />
                                                <span>Module 08 : </span>
                                                Deep JavaScript
                                            </li>
                                            <li>
                                                <CastForEducation />
                                                <span>Module 09 : </span>
                                                React And React Native
                                            </li>
                                            <li>
                                                <CastForEducation />
                                                <span>Module 10 : </span>
                                                React Router
                                            </li>
                                            <li>
                                                <CastForEducation />
                                                <span>Module 11 : </span>
                                                Hooks
                                            </li>
                                            <li>
                                                <CastForEducation />
                                                <span>Module 12 : </span>
                                                Styled Component
                                            </li>
                                            <li>
                                                <CastForEducation />
                                                <span>Module 13 : </span>
                                                React Animation
                                            </li>
                                            <li>
                                                <CastForEducation />
                                                <span>Module 14 : </span>
                                                Node JS
                                            </li>
                                            <li>
                                                <CastForEducation />
                                                <span>Module 16 : </span>
                                                MongoDB
                                            </li>
                                            <li>
                                                <CastForEducation />
                                                <span>Module 16 : </span>
                                                Firebase
                                            </li>
                                        </ul>

                                    </div>
                                    <h3>পূর্বশর্ত</h3>
                                    <div className="why-you-learn" data-aos="zoom-out-up">
                                        <ul>
                                            <li><span><Check /></span> কম্পিউটার সম্পর্কে ধারণা থাকতে হবে </li>
                                            <li><span><Check /></span> ব্রাউজিং সম্পর্কে জানা আবশ্যক</li>
                                            <li><span><Check /></span> 5-6 ঘন্টা অনুশীলন সময় আবশ্যক </li>
                                            <li><span><Check /></span>  Core I3,RAM 4GB,SSD ল্যাপটপ থাকা লাগবে </li>
                                            <li><span><Check /></span> বেসিক HTML , CSS  এর ধারণা আবশ্যক </li>
                                            <li><span><Check /></span> বেসিক জাভাস্ক্রিপ্ট জানা আবশ্যক </li>
                                            <li><span><Check /></span> Become an expert in Statistics</li>
                                            <li><span><Check /></span> Become an expert in Statistics</li>
                                        </ul>
                                    </div>

                                </div>

                            </div>
                        </Col>
                        <Col lg={4} md={6}>
                            <div className="courses-sidebar-information" data-aos="zoom-out-up">
                                <ul className="info">
                                    <li>
                                        <div className="d-flex justify-content-between align-items-center">
                                            <span>  <AccountCircle />  Instructor </span>
                                            Sanjoy Banik
                                        </div>
                                    </li>
                                    <li>
                                        <div className="d-flex justify-content-between align-items-center">
                                            <span> <AccessTime />  Duration</span> 4 Months
                                        </div>
                                    </li>
                                    <li>
                                        <div className="d-flex justify-content-between align-items-center">
                                            <span><PlayLesson /> Lessons</span>60
                                        </div>
                                    </li>
                                    <li>
                                        <div className="d-flex justify-content-between align-items-center">
                                            <span><SettingsAccessibility /> Access</span>Lifetime
                                        </div>
                                    </li>
                                    <li>
                                        <div className="d-flex justify-content-between align-items-center">
                                            <span><Quiz /> Quizzes</span>YES
                                        </div>
                                    </li>
                                    <li>
                                        <div className="d-flex justify-content-between align-items-center">
                                            <span><VerifiedUser /> Certificate</span>YES
                                        </div>
                                    </li>
                                </ul>

                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>


            <Footer />




        </>
    );
};

export default SingleWebDevelopment;